import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, ShieldCheck } from 'lucide-react';
import { useAdminStoreView } from '../context/AdminStoreViewContext';

export default function AdminStoreViewBanner({ className = '' }) {
  const navigate = useNavigate();
  const { isStoreView, returnPath, exitStoreView } = useAdminStoreView();

  if (!isStoreView) return null;

  const returnToAdmin = () => {
    const destination = returnPath;
    exitStoreView();
    navigate(destination);
  };

  return (
    <section
      aria-label="Administrator customer view"
      data-testid="admin-store-view-banner"
      className={`sticky z-40 border-b border-[hsl(var(--warning)/0.45)] bg-background shadow-sm ${className}`}
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-6">
        <div className="flex min-w-0 items-start gap-3">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[hsl(var(--warning)/0.25)] text-[hsl(var(--warning))]">
            <Eye className="h-5 w-5" aria-hidden="true" />
          </span>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-foreground">Customer view</p>
            <p className="text-xs leading-relaxed text-muted-foreground">
              You are viewing the storefront layout. Account data and any actions still use your administrator account.
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={returnToAdmin}
          data-testid="admin-store-view-return"
          className="inline-flex min-h-[44px] shrink-0 items-center justify-center gap-2 rounded-lg border border-primary bg-primary px-4 text-sm font-semibold text-primary-foreground transition-colors hover:bg-[hsl(var(--primary-hover))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 active:scale-[0.98]"
        >
          <ShieldCheck className="h-4 w-4" aria-hidden="true" />
          Return to admin
        </button>
      </div>
    </section>
  );
}
